import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// ai_knowledge_categories — Knowledge base category master data
// ============================================================================
export const aiKnowledgeCategories = sqliteTable("ai_knowledge_categories", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(), // e.g. "นโยบาย", "FAQ"
  color: text("color"), // e.g. "blue", "green", "purple", "gray"
  icon: text("icon"), // lucide icon name e.g. "FileText", "HelpCircle"
  sortOrder: integer("sort_order").default(0),
  isActive: integer("is_active").default(1),
  // Audit fields
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
});

export type AiKnowledgeCategory = typeof aiKnowledgeCategories.$inferSelect;
export type NewAiKnowledgeCategory = typeof aiKnowledgeCategories.$inferInsert;
